import { Environment, PresentationControls } from "@react-three/drei";
import { Suspense } from 'react'
import FluxTeapots from './FluxTeapots'




export default function ResultsFlux()
{
    return <>
        <Environment  preset="warehouse" blur={ .5 }/>
        <directionalLight
            position={ [ 1, 2, 3 ] }
            intensity={ 1.5 }
            castShadow
            shadow-mapSize={ [ 2048, 2048 ] }
            shadow-camera-near={ 1 }
            shadow-camera-far={ 10 }
            shadow-camera-top={ 5 }
            shadow-camera-right={ 5 }
            shadow-camera-bottom={ -5 }
            shadow-camera-left={ -5 }
            shadow-normalBias={ 0.02 }
        />
        <ambientLight intensity={ 0.5 } />
        <Suspense>
            <PresentationControls
                global
                rotation={ [ 0.13, 0.15, 0.1 ] }
                polar={ [ - 2.25, 2.25 ] }
                // azimuth={ [ - 2.75, 2.75 ] }
                // config={ { mass: 2, tension: 200 } }
                // snap={ { mass: 4, tension: 400 } }
            >
                
                <FluxTeapots />
           
            </PresentationControls>
        </Suspense>
    </>
}